import { apiSlice } from "../../app/api/apiSlice";

export const setMaxLoanAmountApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		setMaxLoanAmount: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/user/set_admin_configuration/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useSetMaxLoanAmountMutation } = setMaxLoanAmountApiSlice;
